export default {
  ...window.epAppData
}